import {css} from '@emotion/react'
import {decodeBr} from './utils.mjs'

export const isTable = ({headers, tableName}) => ! (
    void 0 === headers ||
    void 0 === tableName
)

const cssTable = css({
    tableLayout: 'fixed',

    'td': {
        whiteSpace: 'pre-wrap',
    },
})

export const Table = ({data, ...props}) => {
    const {tableName, headers, rows} = data

    return (
        <table
            css={cssTable}
            {...props}
        >
            {
                tableName &&
                <caption style={{captionSide: 'top'}}>
                    {decodeBr(tableName)}
                </caption>
            }

            {
                headers &&
                <thead>
                    <tr>
                        {
                            headers.map((e, i) => (
                                <th key={i}>
                                    {decodeBr(e)}
                                </th>
                            ))
                        }
                    </tr>
                </thead>
            }

            {
                rows &&
                <tbody>
                    {
                        rows.map(
                            (cells, i) => (
                                <tr key={i}>
                                    {
                                        cells.map((e, j) => (
                                            <td key={j}>
                                                {decodeBr(e)}
                                            </td>
                                        ))
                                    }
                                </tr>
                            )
                        )
                    }
                </tbody>
            }
        </table>
    )
}
